/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportJobEntity
 */
export interface ExportJobEntity {
    /**
     * 
     * @type {string}
     * @memberof ExportJobEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobEntity
     */
    cardSystemId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobEntity
     */
    exportType?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportJobEntity
     */
    personId?: string;
}

export function ExportJobEntityFromJSON(json: any): ExportJobEntity {
    return ExportJobEntityFromJSONTyped(json, false);
}

export function ExportJobEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportJobEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'exportType': !exists(json, 'exportType') ? undefined : json['exportType'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
    };
}

export function ExportJobEntityToJSON(value?: ExportJobEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardSystemId': value.cardSystemId,
        'carePrincipalId': value.carePrincipalId,
        'exportType': value.exportType,
        'personId': value.personId,
    };
}

